define(
	'Tavano.TTVatTaxes.VATTaxes',
	[
		'Tavano.TTVatTaxes.VATTaxes.View',
		'VATTaxes.ExtraLabel.View',
		'underscore',
		'Backbone',
		'LiveOrder.Model'
	],
	function (
		VATTaxesView,
		VATTaxesExtraLabelView,
		_,
		Backbone,
		LiveOrderModel
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');
				this.pdp = container.getComponent('PDP');
				var self = this;

				if (layout) {
					layout.addChildView('Product.Price', function () {
						return new VATTaxesExtraLabelView({ excVat: true });
					});
					layout.addChildView('ProductViewsPrice.Price', function () {
						return new VATTaxesExtraLabelView({ excVat: true, isPLP: true });
					});
					layout.addChildView('Item.Summary.View', function () {
						return new VATTaxesExtraLabelView({ excVat: true, isCart: true });
					});
					layout.addChildView('Item.Price', function () {
						return new VATTaxesExtraLabelView({ excVat: true });
					});

					var vatTaxesView = new VATTaxesView({ container: container });
					layout.addChildView('Header.Profile', function () {
						return vatTaxesView;
					});

					layout.addToViewContextDefinition('ProductViews.Price.View', 'priceFormatted', 'string', function (context) {
						return self.calculatePrice(context, { isActive: false });
					});

					layout.addToViewContextDefinition('QuantityPricing.View', 'priceSchedule', 'array', function (context) {
						var priceSchedule = _.map(context.priceSchedule, function (price) {
							price.price_formatted = self.calculatePrice({ price: price.price, multiPrice: true }, { isActive: false }) + ' ' + 'Ex. VAT';
							return price;
						});
						return priceSchedule
					});

					layout.addToViewContextDefinition('Cart.Item.Summary.View', 'totalFormatted', 'string', function (context) {
						return self.calculatePrice(context, { isActive: false, isCart: true });
					});

					layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'rateFormatted', 'string', function (context) {
						var isActive = $('.toggle-switch').hasClass('active');
						return self.calculatePrice(context, { isActive: isActive, isMiniCart: true });
					});
					layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'vatLabel', 'string', function (context) {
						var isActive = $('.toggle-switch').hasClass('active');
						return isActive ? 'Incl. VAT' : 'Ex. VAT';
					});

					layout.addToViewContextDefinition('Header.MiniCart.View', 'subtotalFormatted', 'string', function (context) {
						var isActive = $('.toggle-switch').hasClass('active');
						return self.calculatePricePerLine(context, isActive);
					});

					layout.addToViewContextDefinition('Header.MiniCart.View', 'vatLabel', 'string', function (context) {
						var isActive = $('.toggle-switch').hasClass('active');
						return isActive ? 'Incl. VAT' : 'Ex. VAT';
					});

					vatTaxesView.on('vatTaxes:change', function (data) {
						Backbone.trigger('vatTaxes:change');

						var order = LiveOrderModel.getInstance()
						order.save();

						layout.removeToViewContextDefinition('ProductViews.Price.View', 'priceFormatted', function (context) { });
						layout.removeToViewContextDefinition('QuantityPricing.View', 'priceSchedule', function (context) { });
						var isActive = data.toggle;
						layout.addToViewContextDefinition('ProductViews.Price.View', 'priceFormatted', 'string', function (context) {
							return self.calculatePrice(context, { isActive: isActive });
						});

						layout.addToViewContextDefinition('QuantityPricing.View', 'priceSchedule', 'array', function (context) {
							var priceSchedule = _.map(context.priceSchedule, function (price) {
								price.price_formatted = self.calculatePrice({ price: price.price, multiPrice: true }, { isActive: isActive }) + ' ' + (isActive ? 'Incl. VAT' : 'Ex. VAT');
								return price;
							});
							return priceSchedule
						});

						layout.removeToViewContextDefinition('Cart.Item.Summary.View', 'totalFormatted', function (context) { });
						layout.addToViewContextDefinition('Cart.Item.Summary.View', 'totalFormatted', 'string', function (context) {
							return self.calculatePrice(context, { isActive: isActive, isCart: true });
						});

						var view = container.getLayout().getCurrentView();
						var childView = view.getChildViewInstance('Product.Price');
						if (childView) {
							childView.render();
						}
						var facetChildView = view.getChildViewInstance('Facets.Items');
						if (facetChildView) {
							facetChildView.render();
						}

						var correlatedItemsView = view.getChildViewInstance('Correlated.Items');
						if (correlatedItemsView) {
							correlatedItemsView.render();
						}

						var itemListNavigableView = view.getChildViewInstance('Item.ListNavigable');
						if (itemListNavigableView) {
							itemListNavigableView.render();
						}

						var qtyPricingView = view.getChildViewInstance('Quantity.Pricing');
						if (qtyPricingView) {
							qtyPricingView.render();
						}
					});

				}
			},
			calculatePrice: function calculatePrice(context, attributes) {
				var isActive = attributes.isActive;
				var isCart = attributes.isCart;
				var isMiniCart = attributes.isMiniCart;
				var itemInfo = this.pdp.getItemInfo();
				var vatTaxes = (SC.CONFIGURATION && SC.CONFIGURATION.VATTaxes && SC.CONFIGURATION.VATTaxes.config) || [];
				if (context.multiPrice) {
					var itemTax = itemInfo && itemInfo.item && itemInfo.item.taxschedule
				} else {
					var itemTax = (context.line && context.line.item && context.line.item.taxschedule) || (context.model && context.model.taxschedule) || (context.model.item && context.model.item.taxschedule) || null;
				}
				if (!itemTax) {
					return isCart ? context.totalFormatted : (isMiniCart ? context.rateFormatted : context.priceFormatted);
				}
				var selectedTax = _.find(vatTaxes, function (tax) {
					return tax.type.toLowerCase().trim() === itemTax.toLowerCase().trim();
				});
				if (selectedTax) {
					var taxRate = selectedTax.rate;
					var price = isCart ? context.line.amount : (isMiniCart ? context.line.rate : context.price);
					if (!price) {
						return isCart ? context.totalFormatted : (isMiniCart ? $('.header-mini-cart-item-cell-product-price').val() : context.priceFormatted);
					}
					var newPrice;
					if (!isActive) {
						if (isCart || isMiniCart) {
							newPrice = price;
						} else {
							newPrice = price / (1 + (taxRate / 100));
						}
					} else {
						if (isCart || isMiniCart) {
							newPrice = price + (price * (taxRate / 100));
						} else {
							newPrice = price;
						}
					}
					return '£' + newPrice.toFixed(2);
				} else {
					return isCart ? context.totalFormatted : (isMiniCart ? context.rateFormatted : context.priceFormatted);
				}
			},

			calculatePricePerLine: function calculatePricePerLine(context, isActive) {
				var lines = context.model && context.model.lines;
				var vatTaxes = (SC.CONFIGURATION && SC.CONFIGURATION.VATTaxes && SC.CONFIGURATION.VATTaxes.config) || [];
				var totalAmount = 0;
				_.each(lines, function (line) {
					var itemTax = line.item && line.item.taxschedule;
					if (!itemTax) {
						var newPrice = line.amount;
					} else {
						var selectedTax = _.find(vatTaxes, function (tax) {
							return tax.type.toLowerCase().trim() === itemTax.toLowerCase().trim();
						});
						if (selectedTax) {
							var taxRate = selectedTax.rate;
							var price = line.amount;
							if (!isActive) {
								var newPrice = price;
							} else {
								var newPrice = price + (price * (taxRate / 100));
							}
						} else {
							var newPrice = line.amount
						}
					}
					totalAmount += newPrice;
				});
				return '£' + totalAmount.toFixed(2);
			}
		};
	}
);
